import { getNativeInfo } from '@docs/common'
import { useAsyncEffect, useMount } from 'ahooks'
import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { SolutionArticle, getSolutionArticle } from 'servers/recommend'
import ArticleBase from '../ArticleBase'
import Footer from '../LikeFooter'
import { useParams } from 'react-router-dom'

import ResponsiveArticle from '../ArticleBase/ResponsiveArticle'
import usePcAdaptation from '../usePcAdaptation'
import styles from './styles.module.scss'
import { trackLeaveSolutionPage, trackViewSolutionPage, trackViewSolutionPageloading } from '../../../common/track'
import useAraLayout from 'common/useAraLayout'

export const SolutionPageModule = 'SolutionArticle'

const Article = () => {
  const [token, setToken] = useState('')
  const [data, setData] = useState<SolutionArticle>()
  const [loading, setLoading] = useState(true)
  useAraLayout();
  usePcAdaptation()
  const [bannerLoading, setBannerLoading] = useState(true)
  const scrollPercent = useRef(0)

  const { id } = useParams<{ id: string }>()
  const { uid } = useParams<{ uid: string }>()

  const urlParams = new URLSearchParams(window.location.search)
  const uidSEC = urlParams.get('uid')
  const hideFooter = urlParams.get('footer') === '0'
  const noPadding = urlParams.get('htmlcontent') === '1'
  const showFixedHeader = urlParams.get('fixedheader') === '1'

  console.log('URL Params Debug:', {
    footer: urlParams.get('footer'),
    hideFooter,
    htmlcontent: urlParams.get('htmlcontent'),
    noPadding,
    fixedheader: urlParams.get('fixedheader'),
    showFixedHeader
  })
  // 请求数据获取页面数据
  useAsyncEffect(async () => {
    const data = await getSolutionArticle(uid)

    setLoading(false)
    setData(data)
  }, [uid])

  const contentData = useMemo(() => {
    return data?.data.data.attributes
  }, [data?.data.data.attributes])
  // 埋点
  useMount(() => {
    const time = +Date.now()
    trackViewSolutionPage(uidSEC || uid  || id, SolutionPageModule, time)
    const duration = Math.floor(performance.now())
    trackViewSolutionPageloading(uidSEC || uid ||  id, SolutionPageModule, duration)
  })

  const onScrollPercentChange = (percent: number) => {
    if (percent > scrollPercent.current) {
      scrollPercent.current = percent
    }
  }
  // 埋点
  const trackStaying = useCallback(() => {
    const duration = Math.floor(performance.now())
    trackLeaveSolutionPage(uidSEC || uid || id, SolutionPageModule, scrollPercent.current, duration)
  }, [uidSEC, uid, id])

  // banner 懒加载
  useEffect(() => {
    if (contentData?.banner?.data?.attributes.url) {
      const img = document.createElement('img')
      img.src = contentData?.banner?.data.attributes.url
      img.onload = () => {
        setBannerLoading(false)
      }
    } else {
      setBannerLoading(false)
    }
  }, [contentData?.banner?.data])

  // 获取token
  useEffect(() => {
    async function fetchToken() {
      const { token } = await getNativeInfo()
      setToken(token)
    }
    fetchToken()
  }, [])

  return loading || bannerLoading ? (
    <ResponsiveArticle />
  ) : (
    <div className={styles.articleContainer}>
      <ArticleBase
        title={contentData?.title!}
        banner={contentData?.banner?.data}
        body={contentData?.body!}
        subModule={SolutionPageModule}
        id={uidSEC || uid || id}
        onScrollPercentChange={onScrollPercentChange}
        leaveTrack={trackStaying}
        token={token}
        noPadding={noPadding}
        showFixedHeader={showFixedHeader}
      ></ArticleBase>
      {!!token && !hideFooter && (
        <div className={styles.fixedFooter}>
          <Footer
            type="solution"
            id={uidSEC || uid || id}
            uid={uid || id}
            likeCount={data?.total_like ?? 0}
            isLike={data?.is_like ?? false}
            shareTitle={contentData?.title || ''}
            shareContent={contentData?.share_content || ''}
            feedbackPlaceholder={contentData?.feedback_placeholder || ''}
          />
        </div>
      )}
    </div>
  )
}

export default Article
